import { useState } from 'react';
import { Link } from 'react-location';
import useIsMobile from '../Layout/useIsMobile';

import './Header.scss';

export const Header = () => {
  const [logoUrl, setLogoUrl] = useState('/images/header-logo.svg');
  const [isBurgerMenuOpen, setIsBurgerMenuOpen] = useState(false);
  const isMobile = useIsMobile();

  if (isBurgerMenuOpen) {
    document.getElementById("body-app").classList.add("not-scrollable");
  } else {
    document.getElementById("body-app").classList.remove("not-scrollable");
  }

  return (
    <header className="header">
      <div className="header-wrapper">
        <Link
          className="header-logo"
          to="/"
          onMouseEnter={() => !isMobile && setLogoUrl('/images/header-logo-hover.svg')}
          onMouseLeave={() => !isMobile && setLogoUrl('/images/header-logo.svg')}
        >
          <img className="header-logo" src={logoUrl} alt="Logo" />
        </Link>

        <div className="nav-logo-container" onClick={() => setIsBurgerMenuOpen(true)}>
          <img className="nav-logo" src="/images/icon-nav.svg" alt="Nav Logo" />
        </div>

        <nav className="header-nav">
          <Link className="header-link" to="/#projets">Projets</Link>
          <Link className="header-link" to="/a-propos">À propos</Link>
          <Link className="header-link" to="/a-propos#contact">Contact</Link>
        </nav>
      </div>

      <div className={`burger-menu ${isBurgerMenuOpen ? "visible" : ""}`}>
        <div className="burger-container-wrapper">
          <div className="header-wrapper">
            <img className="burger-header-logo" src="/images/header-logo-hover.svg" alt="Logo" />
            <div className="nav-logo-container" onClick={() => setIsBurgerMenuOpen(false)}>
              <img className="close-logo" src="/images/icon-close.svg" alt="Close Logo" />
            </div>
          </div>

          <Link className="burger-header-link" onClick={() => setIsBurgerMenuOpen(false)} to="/#projets">Projets</Link>
          <hr className="burger-separator" />
          <Link className="burger-header-link" onClick={() => setIsBurgerMenuOpen(false)} to="/a-propos">À propos</Link>
          <hr className="burger-separator" />
          <Link className="burger-header-link" onClick={() => setIsBurgerMenuOpen(false)} to="/a-propos#contact">Contact</Link>
        </div>
      </div>
    </header>
  );
};

export default Header